export default __webpack_public_path__ + "static/media/Icon material-chat.18e75cad.svg";